module.exports = __webpack_public_path__ + "static/media/strongly_disagree.5e5f9725.png";